import React, { useEffect, useState } from "react";
import TopHeader from "../Dashoboard/TopHeader";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { saveLoader } from "../../redux/slice/loaderNoti";
import {
  useLazyPropertyServiceQuery,
  useRoomServiceAddMutation,
  useRoomServiceEditMutation,
} from "../../redux/api/api";

const RoomService = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.itemType;
  const service_type = location?.state?.service_type;
  const [btn, setBtn] = useState(false);

  //   RTK QUERY
  const [propertyServiceApi] = useLazyPropertyServiceQuery();
  const [roomServiceAddApi] = useRoomServiceAddMutation();
  const [roomServiceEditApi] = useRoomServiceEditMutation();

  const [monday, setMonday] = useState(false);
  const [tuesday, setTuesday] = useState(false);
  const [wednesday, setWednesday] = useState(false);
  const [thursday, setThursday] = useState(false);
  const [friday, setFriday] = useState(false);
  const [saturday, setSaturday] = useState(false);
  const [sunday, setSunday] = useState(false);
  const [weekendErr, setWeekendErr] = useState(false);
  const [percentage, setpercentage] = useState("");
  const [percentageErr, setpercentageErr] = useState(false);

  const submitHandler = () => {
    if (
      (monday != true &&
        tuesday != true &&
        wednesday != true &&
        thursday != true &&
        friday != true &&
        saturday != true &&
        sunday != true) ||
      percentage?.length == 0
    ) {
      setWeekendErr(true);
    } else {
      const formdata = new FormData();

      formdata.append("weekend_percentage", percentage);

      let weekend_days = "";

      if (monday == true) {
        weekend_days += ",monday";
      }
      if (tuesday == true) {
        weekend_days += ",tuesday";
      }
      if (wednesday == true) {
        weekend_days += ",wednesday";
      }
      if (thursday == true) {
        weekend_days += ",thursday";
      }
      if (friday == true) {
        weekend_days += ",friday";
      }
      if (saturday == true) {
        weekend_days += ",saturday";
      }
      if (sunday == true) {
        weekend_days += ",sunday";
      }

      formdata.append("weekend_days", weekend_days?.slice(1));

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        roomServiceEditApi({
          id: location?.state?.data?.id,
          type: service_type,
          payload: formdata,
        })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        roomServiceAddApi({
          id: location?.state?.data?.id,
          type: service_type,
          payload: formdata,
        })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      }
    }
  };

  const getView = () => {
    propertyServiceApi({ id: location?.state?.data?.id, type: service_type })
      .unwrap()
      .then((response) => {
        let weekday = "";
        if (service_type == "room_booking") {
          setpercentage(response?.room_booking?.weekend_percentage);
          weekday = response?.room_booking?.weekend_days;
        } else if (service_type == "room_sharing") {
          setpercentage(response?.room_sharing?.weekend_percentage);
          weekday = response?.room_sharing?.weekend_days;
        } else if (service_type == "just_walking") {
          setpercentage(response?.just_walking?.weekend_percentage);
          weekday = response?.just_walking?.weekend_days;
        } else if (service_type == "day_outing") {
          setpercentage(response?.day_outing?.weekend_percentage);
          weekday = response?.day_outing?.weekend_days;
        } else if (service_type == "get_together") {
          setpercentage(response?.get_together?.weekend_percentage);
          weekday = response?.get_together?.weekend_days;
        }

        if (weekday?.includes("monday")) {
          setMonday(true);
        }
        if (weekday?.includes("tuesday")) {
          setTuesday(true);
        }
        if (weekday?.includes("wednesday")) {
          setWednesday(true);
        }
        if (weekday?.includes("thursday")) {
          setThursday(true);
        }
        if (weekday?.includes("friday")) {
          setFriday(true);
        }
        if (weekday?.includes("saturday")) {
          setSaturday(true);
        }
        if (weekday?.includes("sunday")) {
          setSunday(true);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (types == "edit") {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader
        type={types == "edit" ? "edit-weekend-percen" : "add-weekend-percen"}
      />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <div className="col-md-12">
            <div className="booking-range">
              <div className="title">Weekend Price Change</div>
            </div>

            <div>
              <div className="col-md-12 mt-3">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Select the Weekend Days
                </label>
              </div>
              <div>
                <div className="col-md-12 weekly-price" v-if="weekend">
                  <ul>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-10"
                            className="checkbox-custom"
                            name="checkbox-10"
                            type="checkbox"
                            onClick={() => setMonday(!monday)}
                            checked={monday}
                          />
                          <label
                            for="checkbox-10"
                            className="checkbox-custom-label"
                          >
                            Monday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-11"
                            className="checkbox-custom"
                            name="checkbox-11"
                            type="checkbox"
                            onClick={() => setTuesday(!tuesday)}
                            checked={tuesday}
                          />
                          <label
                            for="checkbox-11"
                            className="checkbox-custom-label"
                          >
                            Tuesday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-12"
                            className="checkbox-custom"
                            name="checkbox-12"
                            type="checkbox"
                            onClick={() => setWednesday(!wednesday)}
                            checked={wednesday}
                          />
                          <label
                            for="checkbox-12"
                            className="checkbox-custom-label"
                          >
                            Wednesday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-13"
                            className="checkbox-custom"
                            name="checkbox-13"
                            type="checkbox"
                            onClick={() => setThursday(!thursday)}
                            checked={thursday}
                          />
                          <label
                            for="checkbox-13"
                            className="checkbox-custom-label"
                          >
                            Thursday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-14"
                            className="checkbox-custom"
                            name="checkbox-14"
                            type="checkbox"
                            onClick={() => setFriday(!friday)}
                            checked={friday}
                          />
                          <label
                            for="checkbox-14"
                            className="checkbox-custom-label"
                          >
                            Friday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-15"
                            className="checkbox-custom"
                            name="checkbox-15"
                            type="checkbox"
                            onClick={() => setSaturday(!saturday)}
                            checked={saturday}
                          />
                          <label
                            for="checkbox-15"
                            className="checkbox-custom-label"
                          >
                            Saturday
                          </label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="col">
                        <div className="form-group">
                          <input
                            id="checkbox-16"
                            className="checkbox-custom"
                            name="checkbox-16"
                            type="checkbox"
                            onClick={() => setSunday(!sunday)}
                            checked={sunday}
                          />
                          <label
                            for="checkbox-16"
                            className="checkbox-custom-label"
                          >
                            Sunday
                          </label>
                        </div>
                      </div>
                    </li>
                  </ul>
                  {weekendErr &&
                    monday != true &&
                    tuesday != true &&
                    wednesday != true &&
                    thursday != true &&
                    friday != true &&
                    saturday != true &&
                    sunday != true && <p className="err">Select Weekday</p>}
                </div>

                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                      Enter the Percentage
                    </label>
                    <input
                      className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                      onChange={(e) => setpercentage(e.target.value)}
                      value={percentage}
                      type={"number"}
                    />
                  </div>
                  {percentage?.length == 0 && percentageErr && (
                    <p className="err">Enter Maximum Childrens</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Row>
            <div className="col-md-12 text-center mt-4 mb-5">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default RoomService;
